// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"10f079a6","455":"180319c9","977":"44ce3664"}[chunkId] + ".chunk.js";
};